"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import Link from "next/link"
import { authClient } from "@/lib/auth-client"

export default function LoginPage() {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setError(null)
    setLoading(true)

    const form = e.currentTarget
    const email = (form.elements.namedItem("email") as HTMLInputElement).value
    const password = (form.elements.namedItem("password") as HTMLInputElement).value

    const result = await authClient.signIn.email({ email, password })

    if (result.error) {
      setError(result.error.message ?? "Не вдалося увійти. Перевірте email та пароль.")
      setLoading(false)
      return
    }

    router.push("/dashboard")
  }

  return (
    <div className="rounded-2xl border border-border bg-card shadow-xl shadow-black/5 dark:shadow-black/30 p-8">
      <h1 className="text-2xl font-semibold text-foreground mb-1">Вхід до акаунту</h1>
      <p className="text-sm text-muted-foreground mb-6">Продовжіть роботу з вашою командою AI-агентів</p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-xs font-medium text-foreground mb-1.5">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            className="w-full px-4 py-2.5 rounded-lg bg-background border border-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-xs font-medium text-foreground mb-1.5">
            Пароль
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            placeholder="••••••••"
            className="w-full px-4 py-2.5 rounded-lg bg-background border border-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition"
          />
        </div>

        {error && (
          <div className="rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2.5 rounded-lg bg-primary text-primary-foreground font-medium shadow-md shadow-primary/20 hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition"
        >
          {loading ? "Входжу..." : "Увійти"}
        </button>
      </form>

      <p className="mt-6 text-center text-sm text-muted-foreground">
        Ще не маєте акаунту?{" "}
        <Link href="/register" className="text-primary hover:text-primary/80 font-medium transition">
          Зареєструватись
        </Link>
      </p>
    </div>
  )
}
